import type { FeedItem } from "@compass/shared/schema/api/feed";
import { Link } from "@tanstack/react-router";
import { CalendarDays, Lock } from "lucide-react";
import { FavoriteButton } from "components/elements/FavoriteButton";
import { useUserTimezone } from "hooks/useUserTimezone";

type Props = Extract<FeedItem, { type: "upcomingCompassEvent" }>;

export const FeedCompassEventCard = ({ compassEvent }: Props) => {
    const timeZone = useUserTimezone();
    const startDate = new Date(compassEvent.start);
    const dateStr = startDate.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        timeZone,
    });
    const timeStr = startDate.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        timeZone,
    });

    return (
        <Link
            to="/private-events"
            className="block rounded-2xl border border-teal-200 bg-teal-50/50 p-4 no-underline shadow-sm transition-shadow hover:shadow-md"
        >
            <div className="mb-2 flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                    <CalendarDays className="h-4 w-4 text-teal-600" />
                    <span className="text-xs font-medium text-teal-600">Private Event</span>
                    <Lock className="h-3 w-3 text-teal-400" />
                </div>
                <FavoriteButton target={{ type: "compassEvent", id: compassEvent.id }} size={16} />
            </div>
            <h3 className="font-semibold text-gray-900">{compassEvent.title}</h3>
            <p className="mt-1 text-sm text-teal-700">
                {dateStr} at {timeStr}
            </p>
            {compassEvent.description && (
                <p className="line-clamp-2 mt-1 text-sm text-gray-500">
                    {compassEvent.description}
                </p>
            )}
        </Link>
    );
};
